import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { AppTranslateService } from '../../services/translate.service';
import { TextToSpeechService } from '../../services/text-to-speech.service';
import { WordCard } from '../../entities/wordcard.model';
import { User } from '../../entities/user.model';
import { TranslateModule } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AnalyticsService } from 'src/app/services/gtag.service';


@Component({
  selector: 'app-word-details-modal',
  templateUrl: './word-details-modal.component.html',
  imports: [IonicModule, CommonModule, TranslateModule],
  standalone: true,
  styleUrls: ['./word-details-modal.component.scss'],
})
export class WordDetailsModalComponent implements OnInit {
  @Input() word!: string;
  @Input() contextSentence!: string;
  @Input() targetLanguage!: string;
  @Input() nativeLanguage!: string;
  @Input() proficiencyLevel!: number;
  @Input() articleId!: string;

  wordCard?: WordCard = undefined;
  loading = true;
  error: string | null = null;
  studying: boolean = false;
  example_card: boolean = false;
  sign_in_message: boolean = false;
  temp_user_message: boolean = false;
  loadingAudio = false;

  constructor(
    private modalController: ModalController,
    private translateService: AppTranslateService,
    private translate: TranslateService,
    private userService: UserService,
    private router: Router,
    private gTagService: AnalyticsService,
    private textToSpeechService: TextToSpeechService
  ) {}

  ngOnInit() {
    // Check if the word is an example card
    if (this.word == "EZ Knews") {
      this.loadDefaultCard();
    } else if (!this.example_card && this.word && this.contextSentence && this.targetLanguage && this.nativeLanguage && this.proficiencyLevel) {
    this.studying = this.userService.checkIfWordInVocab(this.word, this.targetLanguage);
    this.loading = true;
    this.translateService.getWordCard(
      this.word,
      this.contextSentence,
      this.nativeLanguage,
      this.targetLanguage,
      this.proficiencyLevel,
    ).subscribe({
      next: (card) => {
        this.wordCard = card;
        this.loading = false;
      },
      error: (err) => {
        // Translate the error
        this.loading = false;
      }
    });
    } else {
    this.error = 'Missing data for word details.';
    this.loading = false;
    }
  
    // Simulating data fetching for demonstration purposes
    /*this.loading = false;
    this.wordCard = {
      id: '1',
      root_word: this.word,
      translation: 'Translated Word',
      examples: ['Example sentence in native language'],
      example_translations: ['Example sentence in target language'],
    };*/
  }

  loadDefaultCard() {
      this.example_card = true;
      this.loading = false;
      this.getExampleSentences().then(sentences => {
        this.wordCard = {
          root_word: this.word,
          translation: this.translate.instant('TOUR.WORD_CARD_TRANSLATION'),
          examples: sentences,
          example_translations: [
            this.translate.instant('TOUR.WORD_CARD_EXAMPLE_1'),
            this.translate.instant('TOUR.WORD_CARD_EXAMPLE_2'),
            this.translate.instant('TOUR.WORD_CARD_EXAMPLE_3')
          ],
          articleId: this.articleId
        };
      });
  }

  closeModal() {
    this.modalController.dismiss();
  }

  studyWord() {
    this.gTagService.trackEvent('word_details', 'study', this.word);
    if (this.wordCard) {
      this.userService.addWordToVocab(this.wordCard, this.targetLanguage, this.articleId).then(status => {
        if (status === "success") {
          this.studying = true;
        }
        else if(status === "notSignedIn") {
          this.sign_in_message = true;
        }
        else if(status === "temporaryUser") {
          this.temp_user_message = true;
        }
        else if(status === "flashCardError") {
          this.error = 'Error creating flashcard.';
        }
        else {
          console.error("Error adding flashcard:", status);
        }
    });
  }
}

  getExampleSentences(): Promise<string[]> {
    let previousLang  = this.translate.currentLang;
    const examples = ["WORD_CARD_EXAMPLE_1", "WORD_CARD_EXAMPLE_2", "WORD_CARD_EXAMPLE_3"];
    let example_sentences = this.translate.getTranslation(this.targetLanguage).toPromise().then(translations =>
      examples.map(example => translations?.["TOUR"][example] || example)
    );
    //Set the language back to the user's native language
    this.translate.use(previousLang);
    return example_sentences;
  }

  goToLogin() {
    this.modalController.dismiss();
    this.router.navigate(['/login']);
  }

  goToSignUp() {
    this.modalController.dismiss();
    this.router.navigate(['/signup']);
  }

  /**
   * Vocalize the current word card using text-to-speech
   */
  async vocalize(): Promise<void> {
    if (!this.wordCard) {
      console.error('No word card to vocalize');
      return;
    }

    this.loadingAudio = true;
    
    try {
      await this.textToSpeechService.vocalizeWordCard(this.wordCard, this.targetLanguage);
    } catch (error) {
      console.error('Error vocalizing word card:', error);
    } finally {
      this.loadingAudio = false;
    }
  }

  /**
   * Stop audio playback
   */
  stopAudio(): void {
    this.textToSpeechService.stopCurrentAudio();
  }

  /**
   * Check if audio is currently playing
   */
  isAudioPlaying(): boolean {
    return this.textToSpeechService.isCurrentlyPlaying();
  }

}